module.exports = __webpack_public_path__ + "img/Скобка_three_lines.e98fa79c.svg";